import React from 'react';
import { connect } from 'react-redux';
import StatisticsByReactivationMetrics from './StatisticsByReactivationMetrics.js';
import actions from './StatisticsByReactivationMetrics.actions';
import {
    mainSelector,
    getMetrics
} from './StatisticsByReactivationMetrics.selectors';
import ReportByReactivationComponent from '../../../../utils/ReportByReactivationComponent/ReportByReactivationComponent';

const reportUtils = ReportByReactivationComponent.utils;

const StatisticsByReactivationMetricsComponent = connect(
    function mapStateToProps(state, ownProps) {
        const data = mainSelector(state);
        const fallbackMetrics = getMetrics(state);
        const metrics = typeof ownProps.metrics === 'string' && ownProps.metrics.length
            ? ownProps.metrics
            : fallbackMetrics;
        const checkedKeys = reportUtils.getKeysMetric(metrics || reportUtils.getDefStrMetric());

        return {
            data,
            metrics,
            checkedKeys,
            location: state.routing.locationBeforeTransitions
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
            saveServerStorage: actions.saveServerStorage
        };
    }
)(StatisticsByReactivationMetrics);

export default StatisticsByReactivationMetricsComponent;
